<ngb-accordion class="mb-5" #acc="ngbAccordion">
	<ngb-panel>
		<ng-template ngbPanelHeader>
			<button ngbPanelToggle class="accordion-button bg-white btn btn-block text-left d-flex" (click)="clickedAccordionButton()">
				<p class="h5 ml-3 d-inline" style="color: #181c32">Transporte</p>
				<span *ngIf="clicked" title="Item a corregir" aria-label="Item a corregir" [inlineSVG]="'./assets/media/svg/icons/Navigation/Angle-down.svg'" cacheSVG="true" class="ml-auto svg-icon svg-icon-xl svg-icon-primary"></span>
				<span *ngIf="!clicked" title="Item a corregir" aria-label="Item a corregir" [inlineSVG]="'./assets/media/svg/icons/Navigation/Angle-right.svg'" cacheSVG="true" class="ml-auto svg-icon svg-icon-xl svg-icon-primary"></span>
			</button>
		</ng-template>
		<ng-template ngbPanelContent>
			<form [formGroup]="transporteGroupForm">
				<div class="row">
					<div class="col-6 form-group mx-auto">
						<div class="row">
							<div class="col-4 label-control">Rut Transporte</div>
							<div class="col-8">
								<input type="text" required class="form-control" name="rutTransporte" appVerificaRut appFormatRut formControlName="rutTransporte" (change)="onSubmit()" />
								<div *ngIf="transporteGroupForm.controls.rutTransporte && submitted && transporteGroupForm.touched && transporteGroupForm.controls.rutTransporte.invalid" class="text-danger">
									<div *ngIf="transporteGroupForm.controls.rutTransporte.errors?.required && tipoDespacho != 1">Campo Requerido</div>
									<div *ngIf="transporteGroupForm.get('rutTransporte').hasError('VerificacionRutValidator')">Rut inválido</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-6 form-group mx-auto">
						<div class="row">
							<div class="col-4 label-control">Patente</div>
							<div class="col-8">
								<input type="text" class="form-control" maxlength="6" formControlName="patente" required (change)="onSubmit()" />
								<div *ngIf="transporteGroupForm.controls.patente && submitted && transporteGroupForm.touched && transporteGroupForm.controls.patente.invalid" class="text-danger">
									<div *ngIf="transporteGroupForm.controls.patente.errors?.required && tipoDespacho != 1">Campo Requerido</div>
									<div *ngIf="transporteGroupForm.controls.patente.errors?.maxlength">Max 6 caracteres</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-6 form-group mx-auto">
						<div class="row">
							<div class="col-4 label-control">Rut Chofer</div>
							<div class="col-8">
								<input type="text" class="form-control" formControlName="rutChofer" #rutChofer required appVerificaRut appFormatRut (change)="onSubmit()" />
								<div *ngIf="transporteGroupForm.controls.rutChofer && submitted && transporteGroupForm.touched && transporteGroupForm.controls.rutChofer.invalid" class="text-danger">
									<div *ngIf="transporteGroupForm.controls.rutChofer.errors?.required && tipoDespacho != 1">Campo Requerido</div>
									<div *ngIf="transporteGroupForm.get('rutChofer').hasError('VerificacionRutValidator')">Rut inválido</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-6 form-group mx-auto">
						<div class="row">
							<div class="col-4 label-control">Nombre Chofer</div>
							<div class="col-8">
								<input type="text" class="form-control" required formControlName="nombreChofer" (change)="onSubmit()" />
								<div *ngIf="transporteGroupForm.controls.nombreChofer && submitted && transporteGroupForm.touched && transporteGroupForm.controls.nombreChofer.invalid" class="text-danger">
									<div *ngIf="transporteGroupForm.controls.nombreChofer.errors?.required && tipoDespacho != 1">Campo Requerido</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="form-group">
					<div class="d-flex align-items-center">
						<!-- Checkbox para Agregar Manejo Madera -->
						<div class="custom-control custom-switch mr-3">
							<input type="checkbox" class="custom-control-input" id="manejoMaderaCheckbox" formControlName="manejoMaderaCheckbox" />
							<label class="custom-control-label label-control" for="manejoMaderaCheckbox"> Agregar Manejo Madera </label>
						</div>

						<!-- Radio Buttons para tipo de búsqueda -->
						<div class="custom-control custom-radio mr-3" *ngIf="transporteGroupForm.get('manejoMaderaCheckbox').value">
							<input type="radio" id="buscarPorDireccionRadio" name="tipoBusqueda" class="custom-control-input" formControlName="tipoBusqueda" value="direccion" />
							<label class="custom-control-label label-control" for="buscarPorDireccionRadio"> Buscar por Dirección </label>
						</div>

						<div class="custom-control custom-radio" *ngIf="transporteGroupForm.get('manejoMaderaCheckbox').value">
							<input type="radio" id="buscarPorRolAvaluoRadio" name="tipoBusqueda" class="custom-control-input" formControlName="tipoBusqueda" value="rolAvaluo" />
							<label class="custom-control-label label-control" for="buscarPorRolAvaluoRadio"> Buscar por Rol Avalúo </label>
						</div>
					</div>
				</div>

				<div *ngIf="transporteGroupForm.get('tipoBusqueda').value === 'direccion' && transporteGroupForm.get('manejoMaderaCheckbox').value">
					<div class="row">
						<!-- Comuna, Dirección y Número en una misma línea -->
						<div class="col-12 form-group">
							<div class="row">
								<div class="col-md-3 label-control">Comuna</div>
								<div class="col-md-5 label-control">Dirección</div>
								<div class="col-md-2 label-control">Número</div>
							</div>
							<div class="row">
								<!-- Comuna -->
								<div class="col-md-3">
									<ng-select formControlName="comuna" [items]="comunas" placeholder="Comuna" bindValue="codigoSii" [searchable]="true" bindLabel="nombre"> </ng-select>
									<div *ngIf="transporteGroupForm.controls.comuna?.invalid && (transporteGroupForm.controls.comuna?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.comuna.errors?.required">Campo Requerido</div>
									</div>
									<div *ngIf="transporteGroupForm.controls.comunaRolOrigen?.invalid && (transporteGroupForm.controls.comunaRolOrigen?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.comunaRolOrigen.errors?.required">Campo Requerido</div>
									</div>
								</div>
								<!-- Dirección -->
								<div class="col-md-5">
									<input type="text" class="form-control" formControlName="direccionMadera" required placeholder="Dirección" />
									<div *ngIf="transporteGroupForm.controls.direccionMadera?.invalid && (transporteGroupForm.controls.direccionMadera?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.direccionMadera.errors?.required">Campo Requerido</div>
										<div *ngIf="transporteGroupForm.controls.direccionMadera.errors?.maxlength">Máximo 100 caracteres</div>
									</div>
								</div>
								<!-- Número -->
								<div class="col-md-2">
									<input type="number" class="form-control" formControlName="numeroMadera" required placeholder="Número" />
									<div *ngIf="transporteGroupForm.controls.numeroMadera?.invalid && (transporteGroupForm.controls.numeroMadera?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.numeroMadera.errors?.required">Campo Requerido</div>
										<div *ngIf="transporteGroupForm.controls.numeroMadera.errors?.min">Número inválido</div>
									</div>
								</div>
								<!-- Botón para Obtener Información Geográfica -->
								<div class="col-md-2 text-right">
									<button type="button" class="btn btn-sm btn-primary btn-block" (click)="obtenerInformacionGeograficaDesdeDireccion()" [disabled]="isLoading || obtenerInfoDisabled()">
										<span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
										Obtener Información
									</button>
								</div>
							</div>
						</div>
					</div>

					<!-- Tabla para seleccionar predio cuando hay múltiples resultados -->
					<div class="row" *ngIf="showPrediosTable">
						<div class="col-12">
							<h5>Seleccione un Predio</h5>
							<table class="table table-bordered">
								<thead>
									<tr>
										<th>#</th>
										<th>Dirección</th>
										<th>Acciones</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let predio of multiplePredios; let i = index">
										<td>{{ i + 1 }}</td>
										<td>{{ predio.direccion }}</td>
										<td>
											<button class="btn btn-sm btn-success mr-2" (click)="seleccionarPredio(predio)">Seleccionar</button>
											<button class="btn btn-sm btn-info" (click)="abrirMapa(predio, mapModal)">Mapa</button>
										</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>

				<!-- Campos Adicionales para Búsqueda por Rol Avalúo -->
				<div *ngIf="transporteGroupForm.get('tipoBusqueda').value === 'rolAvaluo' && transporteGroupForm.get('manejoMaderaCheckbox').value">
					<div class="row">
						<div class="col-12 form-group">
							<div class="row">
								<div class="col-md-3 label-control">Comuna</div>
								<div class="col-md-6 label-control">Rol Avalúo</div>
							</div>
							<div class="row">
								<!-- Comuna -->
								<div class="col-md-3">
									<ng-select formControlName="comuna" [items]="comunas" placeholder="Comuna" bindValue="codigoSii" [searchable]="true" bindLabel="nombre"> </ng-select>
									<div *ngIf="transporteGroupForm.controls.comuna?.invalid && (transporteGroupForm.controls.comuna?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.comuna.errors?.required">Campo Requerido</div>
									</div>
								</div>
								<!-- Rol Avalúo -->
								<div class="col-md-6">
									<input type="text" class="form-control" formControlName="rolAvaluo" required placeholder="Rol Avalúo (ejemplo: 12345-6789)" />
									<div *ngIf="transporteGroupForm.controls.rolAvaluo?.invalid && (transporteGroupForm.controls.rolAvaluo?.touched || submitted)" class="text-danger">
										<div *ngIf="transporteGroupForm.controls.rolAvaluo.errors?.required">Campo Requerido</div>
										<div *ngIf="transporteGroupForm.controls.rolAvaluo.errors?.pattern">Formato inválido. Debe contener solo números y un guión, sin espacios.</div>
									</div>
								</div>
								<!-- Botón para Obtener Información Geográfica -->
								<div class="col-md-2 text-right">
									<button type="button" class="btn btn-sm btn-primary btn-block" (click)="obtenerInformacionGeograficaDesdeRol()" [disabled]="isLoading || obtenerInfoDisabled()">
										<span *ngIf="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"> </span>
										Obtener Información
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Formulario Manual cuando no hay resultados -->
				<div class="row" *ngIf="showManualForm">
					<div class="col-12">
						<h5>No se encontraron coincidencias. Por favor, reintente</h5>
					</div>
				</div>
				<div class="row" *ngIf="informacionGeografica">
					<!-- Rol Origen -->
					<div class="col-md-2 col-sm-4 form-group">
						<label class="label-control">Rol Origen</label>
						<input type="text" class="form-control" formControlName="mnzRolOrigen" readonly />
					</div>

					<!-- Predio Rol Origen -->
					<div class="col-md-2 col-sm-4 form-group">
						<label class="label-control">Predio Rol Origen</label>
						<input type="text" class="form-control" formControlName="prdRolOrigen" readonly />
					</div>

					<!-- Referencia CONAF -->
					<div class="col-md-2 col-sm-4 form-group">
						<label class="label-control">Referencia CONAF</label>
						<input type="text" class="form-control" formControlName="codPlanConaf" (change)="onSubmit()" />
						<div *ngIf="(transporteGroupForm.controls.codPlanConaf?.touched || submitted)" class="text-danger">
							<div *ngIf="transporteGroupForm.controls.codPlanConaf.errors?.required">Campo Requerido</div>
						</div>
					</div>

					<!-- Latitud -->
					<div class="col-md-2 col-sm-6 form-group">
						<label class="label-control">Latitud</label>
						<input type="text" class="form-control" formControlName="latitudOrigenMadera" readonly />
					</div>

					<!-- Longitud -->
					<div class="col-md-2 col-sm-6 form-group">
						<label class="label-control">Longitud</label>
						<input type="text" class="form-control" formControlName="longitudOrigenMadera" readonly />
					</div>

					<!-- Botón "Ver Mapa" -->
					<div class="col-md-2 col-sm-12 form-group">
						<label class="label-control"> </label>
						<button type="button" class="btn btn-secondary btn-sm btn-block" (click)="abrirMapa(informacionGeografica, mapModal)"><i class="fa fa-map-marker"></i> Ver Mapa</button>
					</div>
				</div>
			</form>
		</ng-template>
	</ngb-panel>
</ngb-accordion>

<ng-template #mapModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Ubicación en Mapa</h5>
		<button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<div *ngIf="latitudMapa && longitudMapa; else noCoords">
			<p class="mb-3"><strong>Dirección:</strong> {{ direccionMapa }}</p>
			<iframe width="100%" height="400" frameborder="0" style="border: 0" [src]="mapaEmbedUrl" allowfullscreen> </iframe>
		</div>
		<ng-template #noCoords>
			<p>No se disponen de coordenadas para mostrar el mapa.</p>
		</ng-template>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Cerrar</button>
	</div>
</ng-template>
